import { RefObject, useEffect } from "react";
import { useLocation } from "react-router-dom";

export const ScrollToTop = ({
  ref,
}: {
  ref: RefObject<HTMLDivElement | null>;
}) => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (ref && ref.current) {
      ref.current.scrollTop = 0;
      if (document?.getElementById("appMainBody")) {
        document.getElementById("appMainBody")!.scrollTop = 0;
      }
    }
    // eslint-disable-next-line
  }, [ref, pathname]);

  return null;
};
